import { Box } from '@mui/material';
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { STORAGE_KEYS } from '../constants/storageKeys';
import Sidebar from '../scenes/global/Sidebar';

const Layout = () => {
  // Example authentication check (replace this with your actual auth logic)
  const isAuthenticated = !!sessionStorage.getItem(STORAGE_KEYS.TOKEN);

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <Box
      display="flex"
      height="100vh"
      sx={{
        overflow: 'hidden',
      }}
    >
      <Sidebar />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          height: '100%',
          overflow: 'auto',
          backgroundColor: '#f8f9fa',
          width: '100%',
          position: 'relative',
          scrollbarWidth: 'thin',
          scrollbarColor: '#00c996 #f1f1f1',
          '&::-webkit-scrollbar': {
            width: '6px',
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: '#f1f1f1',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#00c996',
            borderRadius: '3px',
          },
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default Layout;
